/* eslint-disable @typescript-eslint/no-explicit-any */
import { Fragment, useEffect, useState } from "react";
import {
  PlusIcon,
  SelectArrow,
  TickIcon,
} from "../../../../../../atoms/CustomIcons";
import { Avatar, Card, Select, SelectProps, Tag } from "antd";
import { getValueBeforeUnderscore } from "../../../../../../config/utils";

interface dropdownOptionType {
  id: string;
  name: string;
  image_url?: string;
  type: string;
  service_provision_type: string;
  service_line_name?: string;
  parent_id?: string;
  parent_name?: string;
  service_line_id?: string;
}

interface materialDropdownType {
  id: string;
  name: string;
}

type TagRender = SelectProps["tagRender"];

const { Option } = Select;
const { Meta } = Card;

interface DropDownProps {
  estimateFormData: any;
  proposalData: any;
  setGroupedData: React.Dispatch<React.SetStateAction<any[]>>;
  combineDropDown: any[];
  setCombineDropDown: React.Dispatch<React.SetStateAction<any[]>>;
  setSelectedServiceIds: React.Dispatch<React.SetStateAction<string[]>>;
}

export default function EstimateDropDown(props: DropDownProps) {
  const {
    setGroupedData,
    estimateFormData,
    proposalData,
    combineDropDown,
    setCombineDropDown,
    setSelectedServiceIds,
  } = props;

  const [tempSelectedDropdownIds, setTempSelectedDropdownIds] = useState<
    string[]
  >([]);

  useEffect(() => {
    if (estimateFormData?.services) {
      const servicesOptions = Array.isArray(estimateFormData?.services)
        ? estimateFormData?.services
            ?.filter((item: { parent_id?: string }) => !item?.parent_id)
            ?.map((item: dropdownOptionType) => ({
              name: item?.name, // Service labels are normal strings
              id: item?.id,
              image_url: item?.image_url,
              service_provision_type: item?.service_provision_type,
              service_line_name: estimateFormData?.service_lines?.find(
                (line: { id: string }) => line?.id === item?.service_line_id
              )?.name,
              color: estimateFormData?.service_lines?.find(
                (line: { id: string }) => line?.id === item?.service_line_id
              )?.color,
            }))
        : [];

      // 2. Format the category options, rendering labels as Tags
      const subServicesOptions = Array.isArray(estimateFormData?.services)
        ? estimateFormData?.services
            ?.filter(
              (item: { parent_id?: string }) =>
                item?.parent_id != null && item?.parent_id !== ""
            )
            ?.map((item: dropdownOptionType) => ({
              name: item?.name, // Service labels are normal strings
              id: item?.id,
              image_url: item?.image_url,
              service_provision_type: item?.service_provision_type,
              service_line_name: estimateFormData?.service_lines?.find(
                (line: { id: string }) => line?.id === item?.service_line_id
              )?.name,
              parent_name: estimateFormData?.service_groups?.find(
                (group: { id: string }) => group?.id === item?.parent_id
              )?.name,
              color: estimateFormData?.service_lines?.find(
                (line: { id: string }) => line?.id === item?.service_line_id
              )?.color,
            }))
        : [];

      // 2. Format the category options, rendering labels as Tags
      const materialsOptions = Array.isArray(estimateFormData?.materials)
        ? estimateFormData?.materials?.map((item: materialDropdownType) => ({
            name: item?.name, // Service labels are normal strings
            id: item?.id,
          }))
        : [];

      // 3. Create the grouped structure
      const groupedSelectOptions = [
        {
          label: "Services", // The header for the categories group
          options: servicesOptions, // The array of category options (with Tags)
        },
        {
          label: "Subservices", // The header for the materials group
          options: subServicesOptions, // The array of material options
        },
        {
          label: "Materials", // The header for the materials group
          options: materialsOptions, // The array of material options
        },
      ];

      setCombineDropDown(groupedSelectOptions);
    }
  }, [estimateFormData, setCombineDropDown]);

  const optionMap = combineDropDown?.reduce<
    Record<string, { name: string; id: string; color?: string }>
  >((acc, optionGroup) => {
    interface OptionMapValue {
      name: string;
      id: string;
      color?: string;
    }

    interface OptionGroup {
      label: string;
      options: OptionMapValue[];
    }

    (optionGroup as OptionGroup).options.forEach((option: OptionMapValue) => {
      acc[option.id] = option;
    });
    return acc;
  }, {});

  const tagRender: TagRender = (props) => {
    const { value } = props;
    const optionData = optionMap[value];
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        className={
          optionData?.color
            ? getValueBeforeUnderscore(optionData?.color)
            : optionData?.color ?? "default_tag"
        }
        onMouseDown={onPreventMouseDown}
      >
        {optionData?.name}
      </Tag>
    );
  };

  const handleChange = (value: string[]) => {
    setSelectedServiceIds((prevSelected) => [
      ...new Set([...prevSelected, ...value]),
    ]);
    setTempSelectedDropdownIds(value);

    console.log("value", value);
    // const filteredValue = combineDropDown?.filter((group) => {
    //   return group.options.some((option: { id: string }) =>
    //     value.includes(option.id)
    //   );
    // });

    // filteredValue?.forEach((group) => {
    //   if (group?.label === "Materials") {
    //     console.log("group if");
    //   } else {
    //     const filterValue = value?.filter((e) =>
    //       combineDropDown?.some(
    //         (resp) =>
    //           resp?.label !== "Materials" &&
    //           resp?.options?.some((option: { id: string }) => option?.id === e)
    //       )
    //     );
    //     setSelectedServiceIds(filterValue);
    //   }
    // });
  };

  useEffect(() => {
    if (
      proposalData?.data?.services_lines &&
      proposalData?.data?.services_lines?.length > 0
    ) {
      const formattedData = proposalData?.data?.services_lines.map(
        (item: any) => {
          return {
            ...item,
            services: item?.services?.map((service: any) => ({
              ...service,
              visit: service.frequency === "one_time" ? 1 : service.visit,
            })),
            service_groups: item?.service_groups?.map((serviceGroup: any) => {
              return {
                ...serviceGroup,
                services: serviceGroup?.services?.map((service: any) => ({
                  ...service,
                  visit: service.frequency === "one_time" ? 1 : service.visit,
                })),
              };
            }),
          };
        }
      );

      setGroupedData(formattedData || []);

      const allServiceIds: string[] = [];
      proposalData?.data?.services_lines.forEach((item: any) => {
        // Extract IDs from top-level 'services' array
        if (item.services && Array.isArray(item.services)) {
          item.services.forEach((service: { entity_id: string }) => {
            if (service.entity_id) {
              allServiceIds.push(service.entity_id);
            }
          });
        }

        // Extract IDs from 'services' arrays within 'service_groups'
        if (item.service_groups && Array.isArray(item.service_groups)) {
          item?.service_groups?.forEach((group: any) => {
            if (group?.services && Array.isArray(group?.services)) {
              group?.services.forEach((service: { entity_id: string }) => {
                if (service.entity_id) {
                  allServiceIds.push(service.entity_id);
                }
              });
            }
          });
        }
      });

      setSelectedServiceIds(allServiceIds);
      setTempSelectedDropdownIds([]);
    } else {
      setSelectedServiceIds([]);
      setGroupedData([]);
    }
  }, [proposalData?.data, setSelectedServiceIds]);

  return (
    <div className="addEstimateSelect">
      <Select
        popupClassName="option-group-estimate"
        suffixIcon={<SelectArrow />}
        menuItemSelectedIcon={<TickIcon style={{ color: "#00A07D" }} />}
        showSearch
        optionFilterProp="label"
        tagRender={tagRender}
        mode="multiple"
        onChange={handleChange}
        value={tempSelectedDropdownIds}
        placeholder={
          <>
            <PlusIcon /> Add services
          </>
        }
        style={{ display: "none" }}
      >
        {combineDropDown?.length > 0 &&
          combineDropDown?.map(
            (
              resp: {
                label: string;
                options: dropdownOptionType[];
              },
              i: number
            ) => (
              <Fragment key={i}>
                {resp?.options?.length > 0 && (
                  <>
                    <Option value={resp?.label} label={resp?.label} disabled>
                      {resp?.label}
                    </Option>

                    {resp?.options?.map((e: dropdownOptionType) => {
                      return (
                        <Fragment key={e?.id}>
                          <Option value={e?.id} label={e?.name}>
                            <Meta
                              avatar={
                                e?.image_url ? (
                                  <Avatar
                                    src={e?.image_url}
                                    shape="square"
                                    size={36}
                                  />
                                ) : (
                                  <Avatar shape="square" size={36} />
                                )
                              }
                              title={
                                <div className="optionTitle">
                                  <div className="optionTitleText">
                                    {e?.name}
                                  </div>
                                  <Tag>
                                    {resp?.label === "Materials"
                                      ? "Materials"
                                      : e?.service_provision_type === "in_house"
                                      ? "In-house"
                                      : "Subcontracted"}
                                  </Tag>
                                </div>
                              }
                              description={`${e?.service_line_name ?? ""} ${
                                e?.service_line_name && e?.parent_name
                                  ? "/"
                                  : ""
                              }  ${e?.parent_name ?? ""}`}
                            />
                          </Option>
                        </Fragment>
                      );
                    })}
                  </>
                )}
              </Fragment>
            )
          )}
      </Select>
    </div>
  );
}
